import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { theme } from 'styles/theme';
import Image from 'next/image';
import { TitleH1 } from 'components/Typo/TitleH1';
import { ScrollButton } from 'components/commons/ScrollButton';

const Root = styled.header`
  position: relative;
  z-index: 1;
  margin-top: -10rem;
  background-color: ${theme.colors.blueGreen};
  background: linear-gradient(
    180deg,
    rgba(15, 177, 165, 1) 51%,
    rgba(97, 210, 201, 1) 100%
  );
  ${{
    [theme.mediaQueries.md]: {
      marginTop: '10rem',
      backgroundColor: 'transparent',
      background: 'transparent',
    },
  }}
`;

const TopHeader = styled.header`
  margin-top: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 50vh;
  ${{
    [theme.mediaQueries.md]: {
      marginTop: 0,
      clipPath: 'polygon(0 0, 100% 0, 100% 70%, 0% 100%)',
      height: '50vh',
      backgroundColor: theme.colors.blueGreen,
      background: `linear-gradient(
        180deg,
        rgba(15, 177, 165, 1) 51%,
        rgba(97, 210, 201, 1) 100%
        )`,
    },
  }}
`;

const ImageWrapper = styled.div`
  display: block;
  z-index: 1;
  ${{
    [theme.mediaQueries.md]: {
      display: 'none',
    },
  }}
`;

const Title = styled(TitleH1)`
  font-size: 3rem;
  color: white;
  text-transform: uppercase;
  margin-top: 3rem;
  ${{
    [theme.mediaQueries.md]: {
      margin: 0,
      marginTop: '5rem',
      color: theme.colors.white,
    },
  }}
`;

const Wrapper = styled.div`
  display: none;
  ${{
    [theme.mediaQueries.md]: {
      display: 'flex',
      position: 'absolute',
      zIndex: 2,
      right: '3rem',
      bottom: '167px',
    },
  }}
`;

export const Header = () => {
  const { t } = useTranslation('contact');
  return (
    <Root>
      <Wrapper>
        <Image
          src="/assets/pictos/mindsAppWhiteLogo.svg"
          width={170}
          height={170 / 0.97}
          alt="Mindsapp logo"
          quality={100}
          priority
          layout="fixed"
        />
      </Wrapper>
      <TopHeader>
        <ImageWrapper>
          <Image
            alt="Contact"
            src="/assets/pictos/illus_contact.svg"
            height={200}
            width={200 / 1.07}
            priority
          />
        </ImageWrapper>
        <Title>{t('header')}</Title>
      </TopHeader>
      <ScrollButton
        position="absolute"
        scrollTo={80}
        href="#contact-form"
        bottom="45px"
        iconColor={theme.colors.orange}
      />
    </Root>
  );
};
